import gradeType from "../../actions/grade/gradeType";

const initialGrades = [
  { value: "optgroup-1", label: "دبستان" },
  { value: "grade-1", label: "اول" },
  { value: "grade-2", label: "دوم" },
  { value: "grade-3", label: "سوم" },
  { value: "grade-4", label: "چهارم" },
  { value: "grade-5", label: "پنجم" },
  { value: "grade-6", label: "ششم" },
  { value: "optgroup-2", label: "متوسطه دوره اول" },
  { value: "grade-7", label: "هفتم" },
  { value: "grade-8", label: "هشتم" },
  { value: "grade-9", label: "نهم" },
  { value: "optgroup-3", label: "متوسطه دوره دوم" },
  { value: "grade-10", label: "دهم" },
  { value: "grade-11", label: "یازدهم" },
  { value: "grade-12", label: "دوازدهم" },
  { value: "optgroup-4", label: "دانشگاهی" },
];

const initialState = {
  grade: initialGrades,
  loading: false,
  error: false,
  errorMessage: "",
};

const gradeReducer = (state = initialState, action) => {
  switch (action.type) {
    case gradeType.START_FETCHING_GRADE:
      return {
        ...state,
        grade: [],
        loading: true,
        error: false,
      };
    case gradeType.SUCCESS_FETCHIED_GRADE:
      return {
        ...state,
        loading: false,
        grade: action.payload,
        error: false,
      };
    case gradeType.FAILURE_FETCHED_GRADE:
      return {
        ...state,
        loading: false,
        grade: [],
        error: true,
        errorMessage: action.errorMessage,
      };

    default:
      return state;
  }
};

export default gradeReducer;
